export default __webpack_public_path__ + "static/media/security-logo.e46d5720.svg";